module.exports = __webpack_public_path__ + "img/insert.930428eb.svg";